module.exports = __webpack_public_path__ + "media/3_twist.7fe768c6.mp3";